export default function Footer() {
  return (
    <section className="bg-footerBg flex rounded-tr-big">
      <div className="sm:flex sm:flex-wrap sm:justify-around py-10 flex-1 text-center">
        <h2 className="text-white text-4xl font-semibold pt-6">Blogr</h2>
        <div className="py-3">
          <h3 className="py-4 font-semibold text-white">Product</h3>
          <ul className="text-white">
            <li>Overview</li>
            <li>Pricing</li>
            <li>Marketplace</li>
            <li>Features</li>
            <li>Integrations</li>
          </ul>
        </div>
        <div className="py-3">
          <h3 className="py-4 font-semibold text-white">Company</h3>
          <ul className="text-white">
            <li>About</li>
            <li>Team</li>
            <li>Blog</li>
            <li>Careers</li>
          </ul>
        </div>
        <div className="py-3">
          <h3 className="py-4 font-semibold text-white">Connect</h3>
          <ul className="text-white">
            <li>Contact</li>
            <li> Newsletter</li>
            <li>LinkedIn</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
